export const availableLanguages = [
  { name: "English", code: "en" },
  { name: "Español", code: "es" },
  { name: "Català", code: "ca" },
  { name: "Português", code: "pt" },
  { name: "Français", code: "fr" },
  { name: "Nederlands", code: "nl" },
];
export const translations = {
  login: {
    en: "Login",
    es: "Entrar",
    ca: "Entrar",
    nl: "Aanmelding",
    eu: "",
    gl: "",
    pt: "Entrar",
    fr: "Se connecter",
    it: "",
    de: "",
  },
  userName: {
    en: "Username",
    es: "Usuario",
    ca: "Usuari",
    nl: "Gebruikersnaam",
    eu: "",
    gl: "",
    pt: "Usuário",
    fr: "Nom d'utilisateur",
    it: "",
    de: "",
  },
  invalid_credentials_message: {
    en: "Invalid username or password",
    es: "Usuario o contraseña inválido",
    ca: "Usuari o contrasenya invàlid",
    nl: "Ongeldige gebruikersnaam of wachtwoord",
    eu: "",
    gl: "",
    pt: "Usuário ou senha inválidos",
    fr: "Nom d'utilisateur ou mot de passe incorrect",
    it: "",
    de: "",
  },
  userPassword: {
    en: "Password",
    es: "Contraseña",
    ca: "Contrasenya",
    nl: "Wachtwoord",
    eu: "",
    gl: "",
    pt: "Senha",
    fr: "Mot de passe",
    it: "",
    de: "",
  },
  forgot: {
    en: "Forgot?",
    es: "¿Se te ha olvidado?",
    ca: "Se t'ha oblidat?",
    nl: "Vergeten?",
    eu: "",
    gl: "",
    pt: "Esqueceu?",
    fr: "Mot de passe oublié ?",
    it: "",
    de: "",
  },
  userNameWarning: {
    en: "Please enter your username",
    es: "Por favor introduzca el nombre de usuario",
    ca: "Introduïu el nom d'usuari",
    nl: "Voer uw gebruikersnaam in",
    eu: "",
    gl: "",
    pt: "Por favor introduza o usuário",
    fr: "Veuillez entrer votre nom d'utilisateur",
    it: "",
    de: "",
  },
  passwordWarning: {
    en: "Please enter your password",
    es: "Por favor introduce tu contraseña",
    ca: "Si us plau introdueix la teva contrasenya",
    nl: "Voer uw wachtwoord in",
    eu: "",
    gl: "",
    pt: "Por favor introduza sua senha",
    fr: "Veuillez entrer votre mot de passe",
    it: "",
    de: "",
  },
  loggingIn: {
    en: "Logging in...",
    es: "Entrando...",
    ca: "Entrant...",
    nl: "Bezig met aanmelden…",
    eu: "",
    gl: "",
    pt: "Entrando...",
    fr: "Connexion en cours...",
    it: "",
    de: "",
  },
  hello: {
    en: "Hello",
    es: "Hola",
    ca: "Hola",
    nl: "Hallo",
    eu: "",
    gl: "",
    pt: "Oi",
    fr: "Bonjour",
    it: "",
    de: "",
  },
  redirectMsg: {
    en: "we are redirecting you...",
    es: "te estamos redirigiendo...",
    ca: "t'estem redirigint...",
    nl: "u wordt doorgestuurd…",
    eu: "",
    gl: "",
    pt: "você está sendo redirecionado...",
    fr: "Nous vous redirigeons...",
    it: "",
    de: "",
  },
  newVersionMsg: {
    es: "Hay una nueva versión disponible, haz click <a class='newVersionLink' href='https://go.invoxcontact.io/webphonego/'> aquí </a> para acceder. <br/>¡Atención! A partir de Septiembre, serás redirigido a la nueva versión automáticamente.",
    en: "There is a new version available, click <a class='newVersionLink' href='https://go.invoxcontact.io/webphonego/'> here </a> to access. <br/> Attention! From September 1st, you will be automatically redirected to the new version.",
    ca: "Hi ha una nova versió disponible, fes clic <a class='newVersionLink' href='https://go.invoxcontact.io/webphonego/'> aqui </a> per accedir. <br/> Atenció! A partir de Setembre, serà redirigit a la nova versió automàticament.",
    fr: "Une nouvelle version est disponible, cliquez <a class='newVersionLink' href='https://go.invoxcontact.io/webphonego/'> ici </a> pour y accéder. </br>  Attention ! A partir de septembre, vous serez redirigé automatiquement vers la nouvelle version.",
    nl: "There is a new version available, click <a class='newVersionLink' href='https://go.invoxcontact.io/webphonego/'> here </a> to access. <br/> Attention! From September 1st, you will be automatically redirected to the new version.",
    pt: "There is a new version available, click <a class='newVersionLink' href='https://go.invoxcontact.io/webphonego/'> here </a> to access. <br/> Attention! From September 1st, you will be automatically redirected to the new version.",
  },

  mfaMsg: {
    en: "Have multi-factor authentication enabled?",
    es: "¿Tienes activada la autenticación multifactor?",
    ca: "Tens activada l'autenticació multifactor?",
    eu: "Multifaktoreko autentifikazioa gaituta daukazu?",
    gl: "Tes activada a autenticación multifactor?",
    pt: "Tens a autenticação multifator ativada?",
    fr: "Vous avez activé l'authentification multifacteur ?",
    it: "Hai attivato l'autenticazione a più fattori?",
    de: "Hast du die Multi-Faktor-Authentifizierung aktiviert?",
  },
  mfaLinkText: {
    en: "Sign in with multi-factor authentication",
    es: "Inicia sesión con autenticación multifactor",
    ca: "Inicia sessió amb autenticació multifactor",
    eu: "Hasi saioa multifaktoreko autentifikazioarekin",
    gl: "Inicia sesión con autenticación multifactor",
    pt: "Inicia sessão com autenticação multifator",
    fr: "Connectez-vous avec l'authentification multifacteur",
    it: "Accedi con l'autenticazione a più fattori",
    de: "Melde dich mit Multi-Faktor-Authentifizierung an",
  },
};
